export const blogPrefillValue = {
  excerpt:
    "A modern romantic garden wedding filled with warm neutrals, golden hour portraits, and a candlelit dinner reception.",
  contentHtml: `<h1>A Sunset Garden Wedding in Kuala Lumpur: A Modern Romantic Celebration</h1>
<p><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfGJZwl1DhIJ-HC9iBS7bpdMY52Uylh5aKtiWASBMxSygyn3JWE3A6vbk&s=10" alt="Wedding blog cover placeholder" /></p>
<p><strong>Quick Details</strong></p>
<ul>
<li><strong>Venue:</strong> Garden Pavilion, Kuala Lumpur</li>
<li><strong>Theme:</strong> Modern romantic (neutral tones + greenery)</li>
<li><strong>Highlight:</strong> Sunset ceremony + candlelit dinner</li>
<li><strong>Planning:</strong> WeddingServ Team</li>
</ul>
<p>There's something unforgettable about a garden wedding at golden hour - the light is softer, the atmosphere feels calmer, and everything photographs beautifully without needing heavy styling. This wedding was designed with a modern romantic approach: clean details, warm neutrals, and greenery as the main texture.</p>
<p>From the first look to the final dance, the celebration felt intentional, elegant, and deeply personal - the kind of day that's beautiful in photos, but even better in real life.</p>
<h2>Gallery Highlights (2 Columns)</h2>
<div class="columns" cols="2">
  <div class="column">
    <p><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfGJZwl1DhIJ-HC9iBS7bpdMY52Uylh5aKtiWASBMxSygyn3JWE3A6vbk&s=10" alt="Ceremony styling placeholder" /></p>
    <p><strong>Ceremony styling</strong><br />A minimalist arch, soft florals, and clean aisle lines for a timeless look.</p>
  </div>
  <div class="column">
    <p><img src="https://cdn.create.vista.com/api/media/small/268551228/stock-photo-two-gold-wedding-rings-lie-on-the-flowers-of-a-bouquet-close-up" alt="Reception details placeholder" /></p>
    <p><strong>Reception details</strong><br />Candlelight, greenery runners, and warm neutrals for an intimate dinner vibe.</p>
  </div>
</div>
<h2>The Couple's Vision</h2>
<p>The couple wanted the wedding to feel:</p>
<ul>
<li>Naturally elegant (not overly styled)</li>
<li>Modern, clean, and warm</li>
<li>Guest-focused and intimate</li>
<li>Timed around sunset for the ceremony</li>
</ul>
<p>The key was simplicity: fewer design elements, but each one chosen carefully so the whole day stayed cohesive.</p>
<h2>Signature Moments to Include in Your Timeline</h2>
<p>If you want a wedding day that flows well and tells a complete story in photos, consider:</p>
<ul>
<li>A short private moment before walking in</li>
<li>Golden-hour portraits (15-25 minutes)</li>
<li>A heartfelt toast segment (with reactions!)</li>
<li>One "hero" group photo before dinner begins</li>
<li>A final dance to close the night</li>
</ul>
<h2>Final Thoughts</h2>
<p>A wedding doesn't need to be extravagant to feel luxurious. With a clear palette, thoughtful spacing, and warm lighting, you can create a celebration that feels modern, emotional, and timeless.</p>
<p>If you're planning your wedding and want a similar look, start with the mood you want guests to feel - then build the details around that.</p>`,
  contentJson: "",
};
